export default __webpack_public_path__ + "static/media/DSCN6706.80aeb918.JPG";